import * as React from 'react';
import {ErrorMessage} from 'formik';

import * as styles from './formErrors.module.scss';

const ValidationError = ({
  name,
  inverse = false,
}: {
  name: string;
  inverse?: boolean;
}) => (
  <ErrorMessage name={name}>
    {(msg: string) => (
      <p
        className={`${styles.text} ${styles.error} ${
          inverse ? styles.inverse : ''
        }`}>
        {msg}
      </p>
    )}
  </ErrorMessage>
);

export default ValidationError;
